import { addSharingLink, tokenUnavailable } from '../actions/internalActions';
import { addSharePointLink } from '../actions/subscribableActions';
import { createLinkModel } from '../selectors/createLinkModel';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { getFileProviderAuthHeaderValue } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { orchestrator } from 'satcheljs';

orchestrator(addSharePointLink, actionMessage => {
    const linkModel: SharingLinkInfo = createLinkModel(
        actionMessage.linkId,
        actionMessage.url,
        actionMessage.response
    );

    addSharingLink(actionMessage.linkId, linkModel);

    if (!!linkModel.sharingInfo.siteUrl) {
        checkforLinkToken(linkModel.sharingInfo.siteUrl, actionMessage.linkId);
    }
});

async function checkforLinkToken(endpointUrl: string, linkId: string) {
    try {
        await getFileProviderAuthHeaderValue(
            AttachmentDataProviderType.OneDrivePro,
            false /* force refresh */,
            endpointUrl
        );
    } catch {
        tokenUnavailable(linkId);
    }
}
